import React from "react";
import ReactDOM from "react-dom";
import "../style/exportStyles.css"; // Add styles here

interface PopUpMenuProps {
  labels: string[];
  callBacks: (() => void)[];
  position: { x: number; y: number };
  onClose: () => any;
}

const PopUpMenu: React.FC<PopUpMenuProps> = ({
  labels,
  callBacks,
  position,
  onClose,
}) => {
  return ReactDOM.createPortal(
    <div
      className="popup-menu-container"
      style={{
        top: position.y + 10,
        left: position.x + 10,
      }}
      onClick={onClose}
    >
      <div className="popup-menu">
        {labels.map((label, index) => (
          <div key={index} className="popup-menu-item">
            <button onClick={callBacks[index]} className="popup-button">
              {label}
            </button>
            {index < labels.length - 1 && (
              <div className="horizontal-divider" />
            )}
          </div>
        ))}
      </div>
    </div>,
    document.body,
  );
};

export default PopUpMenu;
